module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Pretty-Little-LIars-The-Perfectionists.e13725c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Pretty-Little-LIars-The-Perfectionists.jpg
// module id = X0nI
// module chunks = 0